import { State, LENS } from './Data'
import { Action, ActionType } from './Action';

export function reducer(state: State, action: Action): State {
  switch(action.type) {
  case ActionType.LOAD_PAGE__SUCCESS:
    return LENS.page(action.url).set(state, action.page);
  }
}
